<div class="h-full flex flex-col gap-2 z-0 relative overflow-y-auto  p-2 lg:pl-0">
    <div
        class="max-w-6xl p-4 rounded-lg bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 shadow-lg">
        <form [formGroup]="customerForm" (ngSubmit)="onSave()">
            <h1 class="heading">
                {{customerId ? 'Edit' : 'Add'}}
            </h1>
            <hr class="my-4 mt-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
            <section class="grid gap-4 sm:grid-cols-2">
                <!-- Fully Qualified Name -->
                <div class="space-y-1">
                    <label class="subheading after:text-red-600 after:content-['*']">
                        Fully Qualified Name
                    </label>
                    <div>
                        <div>
                            <input formControlName="FullyQualifiedName" type="text" />
                        </div>
                        <div *ngIf="submitted && form.FullyQualifiedName.errors">
                            <p *ngIf="form?.FullyQualifiedName?.errors?.required" class="pt-1 text-red-600 text-xs">
                                Fully Qualified Name is required
                            </p>
                        </div>
                    </div>
                </div>

                <!-- DisplayName -->
                <div class="space-y-1">
                    <label class="subheading after:text-red-600 after:content-['*']">
                        Display Name
                    </label>
                    <div>
                        <div>
                            <input formControlName="DisplayName" type="text" />
                        </div>
                        <div *ngIf="submitted && form.DisplayName.errors">
                            <p *ngIf="form.DisplayName.errors.required" class="pt-1 text-red-600 text-xs">
                                Display Name is required
                            </p>
                        </div>
                    </div>
                </div>

                <!-- email -->
                <ng-container formGroupName="PrimaryEmailAddr">
                    <div class="space-y-1">
                        <label class="subheading after:text-red-600 after:content-['*']">
                            Email
                        </label>
                        <div>
                            <div>
                                <input formControlName="Address" type="text" />
                            </div>
                            <div *ngIf="submitted && primaryEmailAddr.get('Address')?.errors">
                                <p *ngIf="primaryEmailAddr.get('Address')?.errors?.required"
                                    class="pt-1 text-red-600 text-xs">
                                    Email is required
                                </p>

                            </div>
                        </div>
                    </div>
                </ng-container>

                <!-- Contact -->
                <ng-container formGroupName="PrimaryPhone">
                    <div class="space-y-1">
                        <label class="subheading after:text-red-600 after:content-['*']">
                            Free Form Number
                        </label>
                        <div>
                            <div>
                                <input formControlName="FreeFormNumber" type="text" />
                            </div>
                            <div *ngIf="submitted && primaryPhone.get('FreeFormNumber')?.errors">
                                <p *ngIf="primaryPhone.get('FreeFormNumber')?.errors?.required"
                                    class="pt-1 text-red-600 text-xs">
                                    Number is required
                                </p>
                                <p *ngIf="primaryPhone.get('FreeFormNumber')?.errors?.['pattern']" class="pt-1 text-red-600 text-xs">
                                    Enter a valid phone number (10 digits, numbers only)
                                </p>

                            </div>

                        </div>
                    </div>
                </ng-container>



                <!-- address -->
                <ng-container formGroupName="BillAddr">

                    <!-- line1 -->
                    <div class="space-y-1">
                        <label class="subheading after:text-red-600 after:content-['*']">
                            Address
                        </label>
                        <div>
                            <div>
                                <input googlePlace (onSelect)="onSelectAddress($event)" formControlName="Line1"
                                    name="Line1" id="Line1" type="text" />
                            </div>
                        </div>

                        <div *ngIf="submitted && (billAddr.get('Line1')?.errors)">
                            <p *ngIf="billAddr.get('Line1')?.errors?.required" class="pt-1 text-red-600 text-xs">
                                Line1 is required
                            </p>
                        </div>
                    </div>

                    <!-- CountrySubDivisionCode -->
                    <div class="space-y-1">
                        <label class="subheading after:text-red-600 after:content-['*']">
                            Country Sub Division Code
                        </label>
                        <div>
                            <div>
                                <input formControlName="CountrySubDivisionCode" name="CountrySubDivisionCode"
                                    placeholder="" id="address" type="text" />
                            </div>
                        </div>

                        <div *ngIf="submitted && (billAddr.get('CountrySubDivisionCode')?.errors)">
                            <p *ngIf="billAddr.get('CountrySubDivisionCode')?.errors?.required"
                                class="pt-1 text-red-600 text-xs">
                                Country Sub Division Code is required
                            </p>
                        </div>
                    </div>

                    <!-- city -->
                    <div class="space-y-1">
                        <label class="subheading after:text-red-600 after:content-['*']">
                            City
                        </label>
                        <div>
                            <div>
                                <input formControlName="City" name="City" id="City" type="text" />
                            </div>
                            <div *ngIf="submitted && (billAddr.get('City')?.errors)">
                                <p *ngIf="billAddr.get('City')?.errors?.required" class="pt-1 text-red-600 text-xs">
                                    City is required
                                </p>
                            </div>

                        </div>
                    </div>

                    <!-- Postal code -->
                    <div class="space-y-1">
                        <label class="subheading after:text-red-600 after:content-['*']">
                            Postal Code
                        </label>
                        <div>
                            <div>
                                <input formControlName="PostalCode" name="PostalCode" id="PostalCode" type="text" />
                            </div>
                            <div *ngIf="submitted && (billAddr.get('PostalCode')?.errors)">
                                <p *ngIf="billAddr.get('PostalCode')?.errors?.required"
                                    class="pt-1 text-red-600 text-xs">
                                    Postal Code is required
                                </p>
                            </div>

                        </div>
                    </div>



                    <!-- Country -->
                    <div class="space-y-1">
                        <label class="subheading after:text-red-600 after:content-['*']">
                            Country
                        </label>
                        <div>
                            <div>
                                <input formControlName="Country" name="Country" id="Country" type="text" />
                            </div>
                        </div>

                        <div *ngIf="submitted && (billAddr.get('Country')?.errors)">
                            <p *ngIf="billAddr.get('Country')?.errors?.required" class="pt-1 text-red-600 text-xs">
                                Country is required
                            </p>
                        </div>
                    </div>
                </ng-container>

                <!-- company -->
                <div *ngIf="!customerId" class="space-y-1">
                    <label class="subheading after:text-red-600 after:content-['*']">Company</label>
                    <div>
                        <select [(ngModel)]="selectedCompany" id="Company" [ngModelOptions]="{standalone: true}">
                            <option value="" disabled>Select a company</option>
                            <option *ngFor="let item of companies" [value]="item.id">
                                {{ item.CompanyName | capitalize }}
                            </option>
                        </select>
                    </div>
                    <div *ngIf="submitted && !selectedCompany">
                        <p  class="pt-1 text-red-600 text-xs">
                            Company is required
                        </p>
                    </div>
                </div>

                <div class="space-y-1">
                    <div formGroupName="reference" class="flex gap-2">
                        <div class="w-1/2">
                            <label class="subheading">
                                Ref Name
                            </label>
                            <div>
                                <div>
                                    <input formControlName="name" name="name" id="name" type="text" />
                                </div>
                            </div>
                        </div>
                        <div class="w-1/2">
                            <label class="subheading">
                                Ref ID
                            </label>
                            <div>
                                <div>
                                    <input formControlName="id" name="id" id="id" type="text" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Notes -->
                <div class="space-y-1 col-span-full">
                    <label class="subheading">Notes </label>
                    <div>
                        <div>
                            <textarea formControlName="Notes" type="text" name="" rows="3" class=""> </textarea>
                        </div>
                    </div>
                </div>
            </section>
            <section class="grid gap-4 sm:grid-cols-2 mt-1">
                <div class="space-y-1">
                    <label class="subheading">QB Status (Active/InActive)</label>
                    <div class="sm:col-span-2 flex items-center mt-6 space-x-2">
                        <label
                            class="relative inline-flex h-6 w-12 flex-shrink-0 cursor-pointer rounded-full border-zinc-950/10 dark:border-white/10 bg-zinc-950/5 dark:bg-white/5 text-sm-dark transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2">
                            <input type="checkbox" formControlName="Active" class="peer sr-only" (change)="toggleActive($event)"
                                aria-checked="customerForm.get('Active')?.value" />
                            <span
                                class="pointer-events-none relative inline-block h-6 w-6 transform rounded-full bg-white shadow ring-0 transition-all duration-200 ease-in-out peer-checked:translate-x-6 peer-checked:bg-green-500">
                                <span *ngIf="!customerForm.get('Active')?.value"
                                    class="absolute inset-0 flex h-full w-full items-center justify-center transition-opacity opacity-100 peer-checked:opacity-0"
                                    aria-hidden="true">
                                    <svg class="h-3 w-3 text-red-500" fill="none" viewBox="0 0 12 12">
                                        <path d="M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </span>
                                <span *ngIf="customerForm.get('Active')?.value"
                                    class="absolute inset-0 flex h-full w-full items-center justify-center transition-opacity opacity-100 peer-checked:opacity-100"
                                    aria-hidden="true">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                                        stroke="currentColor" class="h-3 w-3 text-white">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
                                    </svg>
                                </span>
                            </span>
                        </label>
                    </div>
                </div>
            </section>
            <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
            <section class="flex justify-end gap-4">
                <button type="submit" class="btn btn-secondary">
                    {{customerId ? 'Update' : 'Save'}}
                </button>
            </section>
        </form>
    </div>
</div>